import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/", statusCode: 301 }); },
});
